import VisuallyHidden from './VisuallyHidden';

export { Props } from './VisuallyHidden';
export default VisuallyHidden;
